import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import CpntDragAndDropLists from "../../../components/CpntDragAndDropLists";
import { IKeyValueLibelle } from "../../../models/interfaces/IKeyValueLibelle";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";
import { useCompteUpdateActeursJuridiquesMutation, useFetchCompteGetActeursJuridiquesQuery} from "../../../redux/slice/api/FO/compteApi";
import { useFetchSocieteGetActeursJuridiquesQuery } from "../../../redux/slice/api/FO/societeApi";
import { IActeurJuridique } from "../../../models/interfaces/IActeurJuridique";


interface IProps {
  IdCompte: number;
  refetch: boolean;
}


const FOCompteSocieteTabActeursJuridiques: React.FC<IProps> = ({ IdCompte,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 

    /* */
    const [sourceActeursJuridiques, setSourceActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
    const [destinationActeursJuridiques, setDestinationActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
    const [destinationActeursJuridiquesResult, setDestinationActeursJuridiquesResult] = useState<IKeyValueLibelle[]|null>(null);
    //const [searchParams, setSearchParams] = useState<IFilterSociete>();
    const [fetchSocieteActeursJuridiques, setFetchSocieteActeursJuridiques] = useState(refetch);
  
  
    const { data: SocietesResult, isFetching: SocietesisFetching, error: Societeserror } = useFetchSocieteGetActeursJuridiquesQuery(null, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated ,//|| searchParams === null || searchParams === undefined,
    });
  
  
  
    const { data: CompteActeurJuridiqueResult, isFetching: CompteActeurJuridiqueResultFetching, error: CompteActeurJuridiqueResultError, refetch:refetchCompteActeurJuridique} = useFetchCompteGetActeursJuridiquesQuery(IdCompte, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated || IdCompte === 0 || fetchSocieteActeursJuridiques === false,
    });
  
    useEffect(() => {
        setFetchSocieteActeursJuridiques(refetch);
    }, [refetch])
  
  
    const [
      UpdateActeursJuridiquesMutation,
      {
        isSuccess: isSuccessUpdateActeursJuridiques,
        error: errorUpdateActeursJuridiques,
        isLoading:isLoadingUpdateActeursJuridiques
      },
    ] = useCompteUpdateActeursJuridiquesMutation();
  
  
    const PaintSource = () => {
      setSourceActeursJuridiques([]);

      const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

      SocietesResult?.ActeursJuridiques?.forEach((elem: IActeurJuridique) => {
        Tasks.push({
          value: elem.IdExterne?.toString(), //IdCalipse
          key: elem.IdExterne?.toString(), //IdCalipse
          Libelle: elem.Libelle 
        });
      });
      
      setSourceActeursJuridiques(Tasks);



    }
  
    const PaintDestination = () => {
      setDestinationActeursJuridiques([]);

      const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

      CompteActeurJuridiqueResult?.ActeursJuridiques?.map((elem:IActeurJuridique) => {
        Tasks.push({
          value: elem.IdExterne?.toString(), //IdCalipse
          key: elem.IdExterne?.toString(), //IdCalipse
          Libelle: elem.Libelle 
        });
      });

      setDestinationActeursJuridiques(Tasks);

    }
    
  
    useEffect(() => {
      if (!SocietesisFetching && Societeserror === undefined) {
        PaintSource();
      } else {
        setSourceActeursJuridiques(undefined);
      }
    }, [SocietesResult,isSuccessUpdateActeursJuridiques])
  
    useEffect(() => {
      if (!CompteActeurJuridiqueResultFetching && CompteActeurJuridiqueResultError === undefined) {
        PaintDestination();
      } else {
        setDestinationActeursJuridiques(undefined);
      }
    }, [CompteActeurJuridiqueResult,isSuccessUpdateActeursJuridiques])
  


  
  useEffect(() => {
      if (errorUpdateActeursJuridiques !== undefined) {
        toast.warn("Les modifications n'ont pas été prises en compte");
        //setUpdateError(errorUpdateBO)
      }
  }, [errorUpdateActeursJuridiques])
  
  useEffect(() => {
    if (isSuccessUpdateActeursJuridiques) {
      toast.success("Les modifications ont bien été prises en compte.");
      refetchCompteActeurJuridique();
      // setPublication(publication);
      // setUpdateSuccess(true);
    }
  }, [isSuccessUpdateActeursJuridiques])
  
  
    useEffect(() => {
      if (destinationActeursJuridiquesResult) {
        UpdateActeursJuridiquesMutation({
          IdCompte:IdCompte ?? -1,
          //IdsActeurJuridique:destinationActeursJuridiquesResult.map(m => parseInt(m.value))
          ActeursJuridiques: destinationActeursJuridiquesResult?.map(m => ({
            IdExterne: parseInt(m.value),
            Libelle: m.Libelle
        }))
        });
      }
    }, [destinationActeursJuridiquesResult])
  
    const AnnulerCommand = () => {
      PaintDestination();
      PaintSource();
    }
 
  return (
    <>
          {isLoadingUpdateActeursJuridiques
          ?
            <SpinnerEditeurPro text="Mise à jour en cours..." />
          : 
          <CpntDragAndDropLists 
          titresource="Société(s) disponible" 
          source={sourceActeursJuridiques} 
          sourceIsFetching={SocietesisFetching}
          titredestination="Société(s) Attribuée(s)" 
          destination={destinationActeursJuridiques} 
          destinationIsFetching={CompteActeurJuridiqueResultFetching} 
          cmdValider={setDestinationActeursJuridiquesResult} 
          cmdAnnuler={AnnulerCommand} />
          } 
          
    </>
  )
    
}; 

export default FOCompteSocieteTabActeursJuridiques;

